module.exports = __webpack_public_path__ + "img/harsh-braking_map.d566fa81.svg";